import axios from 'axios'

const baseurl = `${process.env.VUE_APP_API_URL}`
const url = `${baseurl}/api/v1`
class StageFourService {
  static getStageFour (id) {
    return axios.get(`${url}/admin/stage-four/fetch/${id}`)
  }
}

export default StageFourService
